import { FC } from "react";

import { getFileUrl } from "@/utils/file/getFileUrl";

import { StyledGalleryContainer, StyledImageWrapper } from "./Styled";

interface SelectableGalleryProps {
    images: string[];
    selectedImages: string[];
    onSelectionChange: (images: string[]) => void;
    allowMultiple?: boolean;
}

export const SelectableGallery: FC<SelectableGalleryProps> = ({
    images,
    selectedImages,
    onSelectionChange,
    allowMultiple = true,
}) => {
    const handleClick = (image: string) => {
        let next: string[];

        if (allowMultiple) {
            next = selectedImages.includes(image)
                ? selectedImages.filter((img) => img !== image)
                : [...selectedImages, image];
        } else {
            next = selectedImages.includes(image) ? [] : [image];
        }

        onSelectionChange(next);
    };

    return (
        <StyledGalleryContainer>
            {images.map((image, index) => (
                <StyledImageWrapper
                    key={index}
                    $selected={selectedImages.includes(image)}
                    onClick={() => handleClick(image)}
                >
                    <img src={getFileUrl(image)} alt={`Фото ${index + 1}`} />
                </StyledImageWrapper>
            ))}
        </StyledGalleryContainer>
    );
};
